#import "./AliyahDetails.graphql"
query AliyotQuery($parashah: ID!, $mine: Boolean!) {
  aliyot(parashah: $parashah, mine: $mine) {
    ...aliyahDetails
  }
}
